import React from 'react';
import { Typography } from '../../../components/Typography';
import { useIntl } from 'react-intl';

interface Props {
  privacyEnabled: boolean;
}

export const PrivacyDisclaimer: React.FC<Props> = ({
  privacyEnabled,
}) => {
  const intl = useIntl();
  return (
    <Typography variant="body1">
      {privacyEnabled
        ? intl.formatMessage({ id: 'privacyEnabledDisclaimer' })
        : intl.formatMessage({ id: 'privacyDisabledDisclaimer' })}
    </Typography>
  );
};
